import React, { FC, forwardRef } from 'react';
import { GenericInputType } from './GenericInputType';

export const GenericHidden: FC<GenericInputType> = forwardRef(({ input, meta, ...rest }, ref) => (
  <input ref={ref} {...input} {...rest} type="hidden" />
));
GenericHidden.displayName = 'GenericHidden';
